import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../../environments/environment";
import {CommonResponse} from "../../../response/common.response";
import {SecurityService} from "../../security.service";
import {UtilityService} from "../../utility.service";


@Injectable({
    providedIn: 'root'
})
export class ApiFilesRepository {
    /**
     * Contiene la ruta de conexión a servicios publicos
     */
    API_URI = environment.API_URI;
    PUBLIC_URI = environment.PUBLIC_URI;

    // tslint:disable-next-line:max-line-length
    constructor(private http: HttpClient, private securityService: SecurityService, private utilityService: UtilityService) {
    }





    // @ts-ignore
    public async getFileFormat(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'files/getFileFormat', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getTypeFilesBooking(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'files/getTypeFilesBooking').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }






}
